<template>
  <div id="add">
    <v-app>
    <v-container fluid grid-list-md>
      <v-flex xs12 sm12 md12>

    <form>

      <v-layout justify-center row wrap>
      <v-flex xs4>
        <span class="headline">Adding {{did}}</span>
        <v-select
        v-model="company"
        :items="companies"
        item-text="company"
        label="Company"
        solo
        >
        </v-select>
      </v-flex>
            </v-layout>
      <v-layout justify-center row wrap>
      <v-flex xs4>
        <v-select
          v-model="devicetype"
          :items="devices"
          item-text="devicetype"
          label="Device Type"
          solo
        >
        </v-select>
      </v-flex>
      </v-layout>
<v-layout justify-center row wrap>
      <v-flex xs2>
      <v-text-field
      v-model="did"
      :mask="'(###) ###-####'"
      return-masked-value
      :error-messages="errors.collect('did')"
      label="DID"
      hint="Input a DID here."
      data-vv-name="did"
      ></v-text-field>
      </v-flex>

      <v-flex xs2>
        <span v-if="didRangeActive">
          {{this.tempdid = ""}}
           <v-text-field
            :mask="'(###) ###-####'"
            return-masked-value
            :error-messages="errors.collect('tempdid')"
            label="Temporary DID"
            data-vv-name="tempdid"
            disabled
            ></v-text-field>
        </span>
        <span v-else>
           <v-text-field
            v-model="tempdid"
            :mask="'(###) ###-####'"
            return-masked-value
            :error-messages="errors.collect('tempdid')"
            label="Temporary DID"
            data-vv-name="tempdid"
            ></v-text-field>
        </span>
      </v-flex>
      </v-layout>



      <v-layout justify-center row wrap>
        <v-flex xs2>
          <v-checkbox
          v-validate="'didRangeActive'"
          v-model="didRangeActive"
          :error-messages="errors.collect('checkbox')"
          label="Range for the DID?"
          data-vv-name="didRangeActive"
          type="didRangeActive"
          required
        ></v-checkbox>
        </v-flex>
        <v-flex xs2>
        <span v-if="didRangeActive">
        <v-text-field
          :disabled="!didRangeActive"
          mask='###'
          v-model="didRange"
          hint="Increases DID by the above amount"
          :error-messages="errors.collect('didRange')"
          label="Range length"
          data-vv-name="didRange"
          required
        ></v-text-field>
        </span>
        <span v-else>
        </span>
        </v-flex>
      </v-layout>

      <v-layout justify-center>
      <span v-if="didRangeActive">
          {{ math }}
      </span>
      <span v-else>
          Not using a range.
      </span>
      </v-layout>

    <v-layout justify-center row wrap>
      <v-flex xs2>
       <v-checkbox
        v-validate="'required'"
        v-model="e911"
        :error-messages="errors.collect('checkbox')"
        label="E911"
        data-vv-name="e911"
        type="e911"
        required
       ></v-checkbox>
      </v-flex>

      <v-flex xs2>
      <v-text-field
      :disabled="!e911"
      v-validate="'required|max:140'"
      v-model="e911address"
      :counter="140"
      :error-messages="errors.collect('e911address')"
      label="E911 Address"
      data-vv-name="e911address"
      required
    ></v-text-field>
    </v-flex>
    </v-layout>

<v-layout justify-center row wrap>
      <v-flex xs1>
      <v-text-field
      v-validate="'required|max:4'"
      v-model="extension"
      :mask="'####'"
      :counter="4"
      :error-messages="errors.collect('extension')"
      label="Extension"
      data-vv-name="extension"
      required
    ></v-text-field>
    </v-flex>
     <v-flex xs3>
      <v-text-field
      v-validate="'required|max:140'"
      v-model="user"
      :counter="20"
      :error-messages="errors.collect('user')"
      label= "User"
      data-vv-name="user"
      required
    ></v-text-field>
    </v-flex>
    </v-layout>

    <v-layout justify-center row wrap>
      <v-flex xs4>
      <v-text-field
      v-validate="'required|max:140'"
      v-model="notes"
      :counter="140"
      :error-messages="errors.collect('notes')"
      label="Notes"
      data-vv-name="notes"
      required
    ></v-text-field>
      <span v-if="didRangeActive">
        <v-btn color="blue lighten-1" type="submit" @click="saveInputRange" to="/">Submit Range</v-btn>
      </span>
      <span v-else>
        <p v-if="this.did.length <= 13" class="text-xs-center">Please enter a DID to continue.</p>
        <v-btn v-if="this.did.length >= 14" color="blue lighten-1" type="submit" @click="saveInput" to="/">Submit</v-btn>
        <v-btn v-if="this.did.length <= 13" color="blue lighten-1" type="submit" @click="saveInput" to="/" disabled>Submit</v-btn>
      </span>
      <v-btn to="/">Cancel</v-btn>
    </v-flex>
    </v-layout>



    </form>
      </v-flex>
  </v-container>
  </v-app>
 </div>
</template>

<script>
import db from './firebaseinit'
export default {
  name: 'add',
  data () {
    return {
      companies: [],
      company: null,
      devices: [],
      device: null,
      devicetype: null,
      did: '',
      tempdid: null,
      didRange: ' ',
      didRangeActive: null,
      e911: false,
      e911address: null,
      extension: null,
      notes: null,
      user: null,
    }
  },
  created () {
    db.collection("companies")
      .orderBy("company")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'company': doc.data().company
          };
          this.companies.push(data);
        });
      });
      db.collection("devices")
      .orderBy("devicetype")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'devicetype': doc.data().devicetype
          };
          this.devices.push(data);
        });
      });
  },
  methods: {
    saveInput () {
      db.collection('inventory').add({
        company: this.company,
        devicetype: this.devicetype,
        did: this.did,
        tempdid: this.tempdid,
        e911: this.e911,
        e911address: this.e911address,
        extension: this.extension,
        notes: this.notes,
        user: this.user
      })
      .then(docRef => this.$router.push('/'))
        .catch(error => console.log(err))
    },
    saveInputRange () {
      var i=0;
      while (i<this.didRange)
      {
      var n = parseInt(this.did.replace(/[^0-9]/g, ''), 10)
      var anotherone = n + i
      var res = anotherone.toString().replace(/(\d{3})(\d{3})(\d{4})/,"($1) $2-$3");
      i++
      db.collection('inventory').add({
        company: this.company,
        devicetype: this.devicetype,
        did: res,
        tempdid: this.tempdid,
        e911: this.e911,
        e911address: this.e911address,
        extension: this.extension,
        notes: this.notes,
        user: this.user
        })
        }
    }
  },
  computed: {
    math: function () {
      // `this` points to the vm instance
      var n = parseInt(this.did.replace(/[^0-9]/g, ''), 10)
      var i = parseInt(this.didRange, 10)
      var calculated = n + i - 1
      var calculation = n.toString().replace(/(\d{3})(\d{3})(\d{4})/,"($1) $2-$3") + ' to ' + calculated.toString().replace(/(\d{3})(\d{3})(\d{4})/,"($1) $2-$3")

      return calculation
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Add.vue